module.exports = __webpack_public_path__ + "static/media/zola-logo-horizontal-black.34453bcb.svg";